import get from 'lodash/get';
import filter from 'lodash/filter';
import { responseDataToMessage } from './message';

export const responseToMessageList = messages => {
  return messages.map(responseDataToMessage);
};

export const Form = data => {
  const filteredMsgs = filter(data.messages, m => m.type === 'chat_message');
  const messages = responseToMessageList(filteredMsgs);
  return {
    id: data.id,
    session: {
      id: data.sessionId,
      trackingId: data.trackingId,
    },
    messages,
  };
};
const responseDataToForm = responseData => {
  return new Form({
    id: get(responseData, 'data.id'),
    sessionId: get(responseData, 'data.relationships.session.data.id'),
    trackingId: get(responseData, 'data.attributes.trackingId'),
    messages: get(responseData, 'included', []),
  });
};

export const responseToFormPost = response => {
  return responseDataToForm(response.data);
};

export const responseToForm = response => {
  return {
    id: get(response, 'data.data.id'),
    questions: get(response, 'data.data.attributes.questions'),
    formValues: get(response, 'data.meta.formValues'),
    proactive: get(response, 'data.data.attributes.proactive'),
  };
};
